import React from 'react';
import AddressCard from './AddressCard';
import EmptyState from '../common/EmptyState';
import { theme } from '../../config/theme';
import { MapPinIcon } from '../icons/Icons';

const AddressList = ({ addresses, onEdit, onDelete, onSetDefault }) => {
  if (!addresses || addresses.length === 0) {
    return (
      <EmptyState
        icon={<MapPinIcon size={48} />}
        title="No addresses added"
        description="Add your first address to get started"
      />
    );
  }

  return (
    <div style={{ display: 'grid', gap: theme.spacing.md }}>
      {addresses.map(address => (
        <AddressCard
          key={address.id}
          address={address}
          onEdit={onEdit}
          onDelete={onDelete}
          onSetDefault={onSetDefault}
        />
      ))}
    </div>
  );
};

export default AddressList;